import type {
  ListSocialContentsParams,
  SocialContent,
  SocialContentDetail,
  SocialContentKind,
  SocialContentSummaryList,
  UpdateSocialContentBody
} from '@api/models';

import { BrowserApiClient } from '@website/lib/api/browser';

/** The social content library: thin wrappers over the generated admin-gated client. */

export interface SocialContentFilters {
  kind?: `${SocialContentKind}`;
  posted?: boolean;
  archived?: boolean;
}

export const listSocialContents = async (
  filters: SocialContentFilters,
  cursor?: string
): Promise<SocialContentSummaryList> =>
  BrowserApiClient.listSocialContents({ ...filters, ...(cursor ? { cursor } : {}) } as ListSocialContentsParams);

export const getSocialContent = async (id: string): Promise<SocialContentDetail> =>
  BrowserApiClient.getSocialContent(id);

export const updateSocialContent = async (id: string, body: UpdateSocialContentBody): Promise<SocialContent> =>
  BrowserApiClient.updateSocialContent(id, body);

export const deleteSocialContent = async (id: string) => BrowserApiClient.deleteSocialContent(id);

/** A fresh 5-minute link; `download` makes the browser save the file instead of showing it. */
export const getSocialFileUrl = async (
  id: string,
  revisionId: string,
  key: string,
  download = false
): Promise<{ url: string; expiresAt: number }> =>
  BrowserApiClient.getSocialFileUrl(id, revisionId, { key, ...(download ? { download: true } : {}) });
